export class DateConverter {
    static getDateStringFormat(date: Date): string {
        if (date) {
            const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
            const dayInMoth = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            return date.getFullYear() + '-' + month + '-' + dayInMoth;
        } else {
            return '';
        }
    }
}

export class NameConverter {
    static unCamelCase (str: string): string {
        return (str || '')
            // insert a space between lower & upper
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // space before last upper in a sequence followed by lower
            .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
            // uppercase the first character
            .replace(/^./, s => s.toUpperCase());
    }

    static dotOrUnderscoreToSpace(str: string): string {
        return str.replace(/(\_\w)/g, s => ' ' + s[1].toUpperCase())
            .replace(/(\.\w)/g, s => ' ' + s[1].toUpperCase());
    }

    static propertyToFriendlyName(str: string): string {
        return NameConverter.unCamelCase(NameConverter.dotOrUnderscoreToSpace(str || ''));
    }
}
